import type { User } from 'firebase/auth';
import apiVariables from './apiVariables';

export interface AccountClaimsResult {
  ok: boolean;
  token: string;
  message?: string;
}

// Both authService.login() and App.tsx's onIdTokenChanged listener need to call
// attach-claims-app 
let inFlight: Promise<AccountClaimsResult> | null = null;
let inFlightUid: string | null = null;

export function ensureAccountClaims(user: User, extraHeaders?: Record<string, string>): Promise<AccountClaimsResult> {
  if (inFlight && inFlightUid === user.uid) {
    return inFlight;
  }

  inFlightUid = user.uid;
  inFlight = (async (): Promise<AccountClaimsResult> => {
    try {
      const currentToken = await user.getIdToken();

      const response = await fetch(apiVariables.ATTCH_AUTH_CLAIMS_IN_TOKEN, {
        method: 'POST',
        headers: { Authorization: `Bearer ${currentToken}`, ...extraHeaders },
        credentials: 'include',
      });

      if (!response.ok) {
        let message = 'Your account is no longer active. Please contact support.';
        try {
          const rawBody = await response.text();
          try {
            const data = JSON.parse(rawBody);
            message = data?.message || rawBody || message;
          } catch {
            message = rawBody || message;
          }
        } catch {
          // keep default message
        }
        return { ok: false, token: currentToken, message };
      }

      const freshToken = await user.getIdToken(true);
      return { ok: true, token: freshToken };
    } finally {
      inFlight = null;
      inFlightUid = null;
    }
  })();

  return inFlight;
}
